module.exports = __webpack_public_path__ + "img/logo_gray@2.c6f8f02d.png";